import api from '@/api/api-axios';
import { User } from '../types/user.type';
export type UpdateUserProfilePayload=Partial<User>;
export const getUserMe=():Promise<any>=>api.get('/users/myInfo');
export const updateUserProfile=(data:UpdateUserProfilePayload):Promise<any>=>api.put('/users/myInfo',data);
export const getUsers=():Promise<any>=>api.get('/users');
export interface ChangePasswordPayload {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export const changePassword = (data: ChangePasswordPayload): Promise<any> =>
  api.post('/users/change-password', data);
